import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { WithStyles, Theme, createStyles, withStyles, Grid, Typography, Icon, Chip } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { fetchNews, fetchMoreNews } from 'src/core/redux/action/newsAction'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import Page from 'src/shared/Page/Page'
import NewsCard from 'src/shared/News/NewsCard'
import NewsTagCloud from 'src/shared/News/NewsTagCloud'
import NewsCardFeatured from 'src/shared/News/NewsCardFeatured'
import NewsCategoriesFilter from 'src/shared/CategoriesFilter/NewsCategoriesFilter'
import { debounce } from 'ts-debounce'
import autobind from 'autobind-decorator'
import Btn from 'src/shared/Btn/Btn'
import { config } from 'src/conf/config'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {css} from 'src/conf/style'
import Alert from 'src/shared/Alert/Alert'
import { slugify } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
  cloudSelected: {
    width: '100%',
    ...css.flexAlCenter
  },
  chip: {
      margin: `0 ${t.spacing.unit}px`,
  },
  counterWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  }
});

const paginateName = 'news';
const paginateAction = fetchNews;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

interface IState {
  tagCloudSelected: string | null
}

class News extends React.Component<IProps, IState> {

  state = {
    tagCloudSelected: null
  }
  
  componentDidMount(){
    const {updateCriteria, promisesWithProgress} = this.props
    promisesWithProgress(updateCriteria("is_public", true))
  }

  render() {
    const {t, classes, news, totalSize, isFetching} = this.props
    const {tagCloudSelected} = this.state
    return (
      <Page>
        <HelmetMeta title={t.App_title_page_News}/>
        {news && 
          <Grid container>
            <Grid item xs={12}>
                <Typography variant="body2">
                <span>Nous vous invitons à prendre connaissance des informations concernant nos publications "Etudes économiques" dans les </span> <a href={`${config.baseUrl}/page/disclaimers`} className="inline-block"> Disclaimers </a><span> accessibles en bas de la présente page.</span>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <NewsCategoriesFilter 
                    onChange={this.debounceonSearch}  
                    reset={click => this.resetFilter = click}  // reset filter when click on cloud
                />
            </Grid>
            {tagCloudSelected &&
                <Grid item xs={12} >
                    <Alert type='info'>
                        <div className={classes.cloudSelected}>
                            <Typography variant="body2"> 
                                Attention, vous filtrez via le nuage de tags. Supprimez ce filtre pour filtrer par catégorie.
                            </Typography>
                            <Chip
                                key={tagCloudSelected}
                                icon={<Icon>cloud</Icon>}
                                label={tagCloudSelected}
                                onDelete={this.resetFilterByCloud}
                                className={classes.chip}
                            />
                        </div>
                    </Alert>
                </Grid>
                }
            <Grid item md={6} xs={12}>
              <NewsCardFeatured pathNews={this.props.match.path} criteria={{is_public: true}}/>
            </Grid>
            <Grid item md={6} xs={12} style={{...css.flexJcCenter}}>
              <NewsTagCloud onFilter={this.filterByTagsCloud} />
            </Grid>
            {news.map(n => {
                return (
                  <Grid item xs={12} md={4} key={`news-grid-${n.id}`}>
                    <NewsCard key={`news-${n.id}`} entity={n} pathNews={this.props.match.path} withChip={true}/>
                  </Grid>
                )
              })
            }
            {news.length < totalSize &&
              <Grid item xs={12} className={classes.counterWrapper}>
                <Btn 
                  color='primary'
                  variant='contained'
                  loading={isFetching}
                  onClick={() => this.loadMoreNews(news.length)}
                >{t.load_more}</Btn>
                <img src="https://counter9.stat.ovh/private/compteurdevisite.php?c=t819nbwjqrpdt6wwh4g6m89nhqnej7dy" style={{border: 0}}></img>
              </Grid>
            }
          </Grid>
        }
        {!news &&
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body2" align="center">{t.news_no_post}</Typography>
            </Grid>
          </Grid>
        }
      </Page>
    )
  }

  @autobind
  private resetFilter(){
    const {updateObjectCriteria, promisesWithProgress, criteria} = this.props
    const newsCriteria = {...criteria}
    delete newsCriteria.category_actu_nuage
    delete newsCriteria.category_actu
    delete newsCriteria.category_produit
    delete newsCriteria.category_principale
    promisesWithProgress(updateObjectCriteria(newsCriteria))
  }

  @autobind
  private resetFilterByCloud(){
    const {updateCriteria, promisesWithProgress} = this.props
    this.setState({tagCloudSelected: null})
    promisesWithProgress(updateCriteria("category_actu_nuage", ""))
  }

  /*
    when clicking the filter by cloud, 
    the filter by category needs to be reset (inside component)
    then rebuild the criteria of all columns for fetching data
  */
  @autobind
  private filterByTagsCloud(tags){
    const {updateCriteria, promisesWithProgress} = this.props
    this.setState({tagCloudSelected: tags.value})
    promisesWithProgress(updateCriteria("category_actu_nuage", slugify(tags.value)))
  }
  
  @autobind
  private loadMoreNews(offset){
    const {loadMore, criteria} = this.props
    const newsCriteria = {...criteria}
    newsCriteria.offset = offset
    loadMore(newsCriteria)
  }

  @autobind
  private filterByCategories(values: any){
    const {criteria} = this.props
    criteria.category_actu_nuage = values.get('actu-nuage')
    criteria.category_actu = values.get('actu')
    criteria.category_produit = values.get('produit')
    criteria.category_principale = values.get('principale')
    this.props.search(criteria)
  }

  private debounceonSearch = debounce(this.filterByCategories, 300)
  
}

const state2props = (state: RootState) => ({
    criteria: state.paginate.news.criteria,
    news: state.paginate.news.entities,
    isFetching: state.paginate.news.isFetching,
    totalSize: state.paginate.news.total_size
});

const dispatch2props = (dispatch: any) => ({
    updateCriteria: (name: string, value: any) => dispatch(actions.updateCriteria(name, value)),
    updateObjectCriteria: (obj: any) => dispatch(actions.updateCriteriaByObject(obj)),
    loadMore: (c: NewsCriteria) => dispatch(fetchMoreNews(c)),
    search: (c: NewsCriteria) => dispatch(fetchNews(c))
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(News)



// WEBPACK FOOTER //
// ./src/page/News/News.tsx